import _ from 'lodash'
import { REQUEST } from 'crom-api-constants'

export const LOCALE_PREFIX =
    'scenes.Gnosus.scenes.Report.components.Workspace.components.Blocks.Estates.components.DistributionTab'

export const LOAD_REALESTATES_ESTATES_DISTRIBUTION_DATA_TABLE = 'LOAD_REALESTATES_ESTATES_DISTRIBUTION_DATA_TABLE'
export const DATA_TABLE_REQUEST = (module, id, blockKey) =>
    `DATA_TABLE_${_.toUpper(module)}_${_.toUpper(id)}_${_.toUpper(blockKey)}_DISTRIBUTION_${REQUEST}`
